import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { useLang } from "../i18n";
import { Header } from "../components/Header";
import { Bunny } from "../components/Bunny";
import { LiveCounter } from "../components/LiveCounter";
import { HowItWorks } from "../components/HowItWorks";
import { Footer } from "../components/Footer";

export default function Landing() {
  const { t } = useLang();
  return (
    <div className="relative min-h-screen bg-white">
      <Header />

      {/* Hero */}
      <section className="relative overflow-hidden px-5 pb-16 pt-28 sm:px-8 sm:pt-32">
        <div
          className="pointer-events-none absolute inset-0 opacity-[0.04]"
          style={{
            backgroundImage:
              "url(https://images.unsplash.com/photo-1607457561901-e6ec3a6d16cf?crop=entropy&cs=srgb&fm=jpg&q=85)",
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        />
        <div className="relative mx-auto grid max-w-6xl items-center gap-10 md:grid-cols-2">
          <div>
            <motion.span
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              data-testid="hero-pill"
              className="inline-flex items-center gap-2 rounded-full bg-softpink px-4 py-1.5 text-xs font-medium tracking-wide text-dusty-dark"
            >
              <span className="h-1.5 w-1.5 rounded-full bg-dusty" />
              {t("org")}
            </motion.span>

            <motion.h1
              initial={{ opacity: 0, y: 12 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, delay: 0.1 }}
              className="mt-6 text-4xl font-semibold leading-[1.08] tracking-tight text-graphite sm:text-5xl lg:text-6xl"
            >
              {t("hero_title")}
            </motion.h1>

            <motion.p
              initial={{ opacity: 0, y: 12 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, delay: 0.2 }}
              className="mt-5 max-w-lg text-base leading-relaxed text-textsec"
            >
              {t("hero_sub")}
            </motion.p>

            <motion.div
              initial={{ opacity: 0, y: 12 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, delay: 0.3 }}
              className="mt-8"
            >
              <Link
                to="/map"
                data-testid="open-map-btn"
                className="group inline-flex items-center gap-2 rounded-btn bg-dusty px-6 py-3.5 text-sm font-medium text-white shadow-soft transition-all hover:-translate-y-0.5 hover:bg-dusty-dark"
              >
                {t("open_map")}
                <ArrowRight size={18} strokeWidth={1.75} className="transition-transform group-hover:translate-x-1" />
              </Link>
            </motion.div>

            <div className="mt-10 max-w-md">
              <LiveCounter />
            </div>
          </div>

          {/* Bunny */}
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1, delay: 0.25 }}
            className="relative hidden items-center justify-center md:flex"
          >
            <div className="absolute h-72 w-72 rounded-full bg-softpink blur-2xl" />
            <Bunny className="relative h-[380px] w-auto drop-shadow-[0_20px_40px_rgba(180,123,132,0.18)]" />
          </motion.div>
        </div>
      </section>

      <HowItWorks />
      <Footer />
    </div>
  );
}
